import React from "react";
import { List, ListItem, ListItemText, Grid } from "material-ui";

import "./index.scss";

const AlternatingCardDetailsList: React.SFC = (props) => {
    return (
        <List className="alternating-card-details-list">{props.children}</List>
    );
};

export default AlternatingCardDetailsList;



// WEBPACK FOOTER //
// ./src/components/AlternatingCardDetailsList/index.tsx